// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"forgotPasswordPage_parentContainer__-rakj","childContainer":"forgotPasswordPage_childContainer__3FoUH","logo":"forgotPasswordPage_logo__2tLhF"};